import { useNavigate } from "react-router-dom";
import HeroSection from "../../components/UserComponents/heroSection.jsx";
import TopExperience from "../../components/UserComponents/topExperience.jsx";
import ExploreYourLocation from "../../components/UserComponents/ExploreYourLocation.jsx";
import ExploreByCategoriesSecond from "../../components/UserComponents/ExploreByCategoriesSecond.jsx";
import BookYourAdventure from "../../components/UserComponents/BookYourAdventure.jsx";
import {
  usePublicCategories,
  usePublicLocations,
  usePublicExperiences,
} from "../../custom-hooks/queries.js";
import { useEffect, useMemo, useState } from "react";
import { debounce } from "../../utils/HelperMethod.js";
import { useAuthStore } from "../../store/useAuthStore.js";
import { jwtDecode } from "jwt-decode";

const UserHomePage = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const [decoded, setDecoded] = useState("");
  const token = useAuthStore.getState().token;

  useEffect(() => {
    if (token) {
      const tokenDecoded = jwtDecode(token);
      setDecoded(tokenDecoded);
    }
  }, []);

  // Fetch categories
  const { data: categoriesData, isLoading: isCategoriesLoading } =
    usePublicCategories();

  // Fetch locations
  const { data: locationsData, isLoading: isLocationsLoading } =
    usePublicLocations();

  // Fetch top experiences (IsTop = true)
  const { data: topExperiencesData, isLoading: isTopExperiencesLoading } =
    usePublicExperiences({
      page: 1,
      pageSize: 10,
      isTop: true,
      search: debouncedValue,
      userId: decoded?.userId,
    });

  // Fetch all experiences
  const { data: allExperiencesData, isLoading: isAllExperiencesLoading } =
    usePublicExperiences({
      page: 1,
      pageSize: 10,
      isTop: false,
      search: debouncedValue,
      userId: decoded?.userId,
    });

  // Map API data (handle different response structures)
  const categories = categoriesData?.data || categoriesData || [];
  const locations = locationsData?.data || locationsData || [];
  const topExperiences =
    topExperiencesData?.data?.data ||
    topExperiencesData?.items ||
    topExperiencesData?.data ||
    [];
  const allExperiences =
    allExperiencesData?.data?.data ||
    allExperiencesData?.items ||
    allExperiencesData?.data ||
    [];

  // Handlers
  const handleCategoryClick = (categoryId) => {
    navigate(`/user/category-detail/${categoryId}`);
  };

  const handleLocationClick = (locationId) => {
    navigate(`/user/location-detail/${locationId}`);
  };

  const handleExperienceClick = (experienceId) => {
    navigate(`/user/experience/${experienceId}`);
  };

  const handleSearchChange = (value) => {
    setSearch(value); // input ke liye instant
    debouncedSearch(value); // API ke liye delayed
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setDebouncedValue(value); // API trigger value
      }, 500),
    [],
  );

  return (
    <>
      <HeroSection
        searchValue={search}
        onSearchChange={handleSearchChange}
        title="Curated Experiences. Clear availability. Easy Booking"
        description="Everything you need to find and book the right experience - without the friction"
        searchPlaceholder="Search experiences or location"
        home={true}
      />
      <ExploreByCategoriesSecond
        categories={categories}
        isLoading={isCategoriesLoading}
        onCategoryClick={handleCategoryClick}
      />
      <TopExperience
        title="Popular nearby experiences"
        showCategories={false}
        showDescription={false}
        showViewAll={true}
        experiences={topExperiences}
        isLoading={isTopExperiencesLoading}
        onExperienceClick={handleExperienceClick}
        onViewAllClick={() =>
          navigate(`/user/experience-detail/?isTop=${true}`)
        }
      />
      <TopExperience
        title="Experiences"
        showCategories={false}
        showDescription={false}
        showViewAll={true}
        experiences={allExperiences}
        isLoading={isAllExperiencesLoading}
        onExperienceClick={handleExperienceClick}
        onViewAllClick={() =>
          navigate(`/user/experience-detail/?isTop=${false}`)
        }
      />
      <BookYourAdventure />
      <ExploreYourLocation
        locations={locations}
        isLoading={isLocationsLoading}
        onLocationClick={handleLocationClick}
      />
    </>
  );
};

export default UserHomePage;
